import { useTranslation } from 'react-i18next';

import { Button } from '@treezor/design-system';

import { useUserWalletOverview } from '../../hooks/useUserWalletOverview';

import { IWallet } from '@/features/wallets/store/models/wallet.model';

import { UserWalletGlobalOverview } from './UserWalletGlobalOverview';
import { WalletItem } from './WalletItem';

interface IWalletOverviewProps {
  wallets: IWallet[];
}

export function UserWalletOverview({ wallets }: IWalletOverviewProps) {
  const { t } = useTranslation();

  const { overviews, displayedWallets, hasAllWallets, handleNavigate, totalRows } = useUserWalletOverview(wallets);

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-start gap-5">
        {overviews.map((item, index) => (
          <UserWalletGlobalOverview
            key={`overview-item-${index}`}
            label={item.label}
            value={item.value}
            hasWarning={item?.hasWarning}
          />
        ))}
      </div>
      <div className="flex flex-col gap-5">
        {displayedWallets.map((wallet) => (
          <WalletItem key={`wallet-overview-item-${wallet.walletId}`} wallet={wallet} handleNavigate={handleNavigate} />
        ))}
        {!hasAllWallets && (
          <div className="flex items-center justify-end">
            <Button variant="ghost" size="s" icon="chevron_right" iconPosition="right" onClick={() => handleNavigate()}>
              {t('pages.currentProfiles.profile.overview.allWallets', { value: totalRows })}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
}
